export function UrlExample({ template, highlight }: { template: string; highlight: string }) {
  const [before, after] = template.split(highlight);

  return (
    <span className="ml-0.5 rounded bg-spark-surface-muted px-1 py-0.5 font-mono text-spark-text-secondary text-xs">
      {before}
      <span className="font-medium text-spark-accent">{highlight}</span>
      {after}
    </span>
  );
}
